<template>

  <div>
      <ul class="navbar-nav bg-gradient sidebar sidebar-dark accordion" id="accordionSidebar">
        <!-- Sidebar - Brand -->
        <router-link to="" class="sidebar-brand d-flex align-items-center justify-content-center">
          <div class="sidebar-brand-text mx-3">
            <img style="height: 80px; padding: 10px" src="https://api.lineapurpura.com/imgs/logo.jpg" alt="">
          </div>
        </router-link>
    
        <!-- Divider -->
        <hr class="sidebar-divider my-0">
    
        <!-- Nav Item - Dashboard -->
        <li class="nav-item active">
            <router-link class="nav-link" to="/">
                <i class="fas fa-fw fa-tachometer-alt"></i>
                <span>Inicio</span>         
            </router-link>
        </li>
    
        <!-- Divider -->
        <hr class="sidebar-divider">
    
        <!-- Heading -->
        <div class="sidebar-heading">Explorar</div>


        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseCases"
            aria-expanded="true"
            aria-controls="collapseCases"
          >
            <i class="fas fa-fw fa-wrench"></i>
            <span>Casos</span>
          </a>
          <div
            id="collapseCases"
            class="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Peticiones:</h6>
              <router-link class="collapse-item" to="/cases">Mis casos</router-link>
            </div>
          </div>
        </li>
    
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#formats"
            aria-expanded="true"
            aria-controls="formats"
          >
            <i class="fas fa-fw fa-wrench"></i>
            <span>Formatos</span>
          </a>
          <div
            id="formats"
            class="collapse"
            aria-labelledby="headingUtilities"
            data-parent="#accordionSidebar"
          >
            <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Formatos:</h6>
              <router-link class="collapse-item" :to="{name: 'entity-formats'}">Mis formatos</router-link>
            </div>
          </div>
        </li>
    
        <!-- Divider -->
        <hr class="sidebar-divider">
    
      </ul>
  </div>
</template>
<script>
export default {
    name: 'sidebar',
}
</script>
<style lang="scss">
    .bg-gradient {
        background-image: linear-gradient(#2352df 80%,rgba(0, 0, 255, 0) 96%) !important;
    }
</style>


